jQuery(document).ready(function ($) {
    "use strict";

    // Add padding to the top of the page to offset the fixed header
    $('body').css({'paddingTop': $('#ld-header').outerHeight()});

    // Enable smooth anchor link scrolling
    // on all link elements (href="#...")
    $.localScroll({target: 'body'});

    // Enable Flickity for all elements with
    // Flickity data attribute. Setting overrides
    // must be set as json string on attribute
    $('[data-flickity]').flickity({
        wrapAround: true,
        cellAlign: 'left',
        autoPlay: '10000'
    });

    $('[data-map]').gMap();

    // Opens Magnific Popup's, using the data attribute to group items into a gallery,
    // For dynamic type to work, you will need to add the class mfp-TYPE to all elements.
    // Use mfp-image for images, mfp-iframe for videos, and mfp-iframe for HTML.
    /* Look at this further, can be more efficient. */
    $('[data-mfp]').on('click', function (e) {
        e.preventDefault();

        $('[data-mfp]').magnificPopup({
            gallery: {
                enabled: true
            }
        }).magnificPopup('open');
    });

    $('body').on('click', '[data-menu]', function(e) {
        e.preventDefault();
        var menu = $(this).data('menu');
        $('div' + menu).toggleClass('popup-menu--active');
    });

    $('body').on('click', '[data-close]', function(e) {
        e.preventDefault();
        var menu = $(this).data('close');
        $('div' + menu).addClass('breaking-news--hidden');
    });

    $('.custom-archive__year').on('click', function() {
        $(this).toggleClass('custom-archive__year--active');
        $(this).next('ul').toggleClass('custom-archive__list--hidden');
    });

    $('.popup-menu__item.menu-item-has-children').on('click', function (e) {
        $(this).toggleClass('popup-menu__item--active');
        $(this).siblings().removeClass('popup-menu__item--active');
    });

    delayFunction(function(){

        if(jQuery('[data-facebook-widget]').length) {
            jQuery.getScript('//connect.facebook.net/en_GB/all.js#xfbml=1', function() {
                FB.init({status: true, cookie: true, xfbml: true});
            });
        }

        if(jQuery('[data-twitter-widget]').length) {
            jQuery.getScript('//platform.twitter.com/widgets.js');
        }

        if(jQuery('[data-light-widget]').length) {
            jQuery.getScript('//lightwidget.com/widgets/lightwidget.js');
        }
    });
});


// var element = document.getElementById("nf-field-49");
// element.classList.add("application-form__dinamic-visible");
//
// var element2 = document.getElementById("nf-field-50");
// element2.classList.add("application-form__dinamic-visible");
//
// var element3 = document.getElementById("nf-field-51");
// element3.classList.add("application-form__dinamic-visible");
//
// var element4 = document.getElementById("nf-field-52-container");
// element4.classList.add("application-form__dinamic-visible");
//
// var element5 = document.getElementById("hidde_1");
// element5.classList.add("application-form__dinamic");

//Application form click to open more



    function myFunction() {

        var lists = document.querySelectorAll(".application-form__dinamic2");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction3() {

        var lists = document.querySelectorAll(".application-form__dinamic3");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction4() {

        var lists = document.querySelectorAll(".application-form__dinamic4");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction5() {

        var lists = document.querySelectorAll(".application-form__dinamic5");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction6() {

        var lists = document.querySelectorAll(".application-form__dinamic6");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction7() {

        var lists = document.querySelectorAll(".application-form__dinamic7");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction8() {

        var lists = document.querySelectorAll(".application-form__dinamic8");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction9() {

        var lists = document.querySelectorAll(".application-form__dinamic9");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction10() {

        var lists = document.querySelectorAll(".application-form__dinamic10");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction11() {

        var lists = document.querySelectorAll(".application-form__dinamic11");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction12() {

        var lists = document.querySelectorAll(".application-form__dinamic12");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction13() {

        var lists = document.querySelectorAll(".application-form__dinamic13");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction14() {

        var lists = document.querySelectorAll(".application-form__dinamic14");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myFunction15() {

        var lists = document.querySelectorAll(".application-form__dinamic15");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__dinamic-visible');
        }
    }

    function myDisablebtn() {

        var lists = document.querySelectorAll("#on_click");
        for(var i = 0; i < lists.length; i++){
            var list = lists[i];
            list.classList.add('application-form__button-disble');
        }
    }

    function myHide() {
        var labels = document.querySelectorAll(".application-form__calendar1");
        for(var i = 0; i < labels.length; i++){
            var label = labels[i];
            label.classList.add('application-form__button-disble');
        }
    }
    function myHide2() {
        var labels2 = document.querySelectorAll(".application-form__calendar2");
        for(var i = 0; i < labels2.length; i++){
            var label2 = labels2[i];
            label2.classList.add('application-form__button-disble');
        }
    }



//Load More clicking on button Application Form
jQuery(document).on( 'nfFormReady', function( e, layoutView ) {
    var button = document.getElementById("on_click"),
      count = 0;
    button.onclick = function() {
      count += 1;
      if (count == 1) {
          myFunction();
      } else if (count == 2) {
          myFunction3();
      } else if (count == 3) {
          myFunction4();
      } else if (count == 4) {
          myFunction5();
      } else if (count == 5) {
          myFunction6();
      } else if (count == 6) {
          myFunction7();
      } else if (count == 7) {
          myFunction8();
      } else if (count == 8) {
          myFunction9();
      } else if (count == 9) {
          myFunction10();
      } else if (count == 10) {
          myFunction11();
      } else if (count == 11) {
          myFunction12();
      } else if (count == 12) {
          myFunction13();
      } else if (count == 13) {
          myFunction14();
      } else if (count == 14) {
          myFunction15();
          myDisablebtn();
      };
    };

});
